<div class="modal-header">
    <h4 class="modal-title">
      <i data-feather="alert-circle"></i> {{data.title}}</h4>
    
  </div>
  <div class="modal-body">
    <p>{{ data.message }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" (click)="confirm()">Evet</button>
  </div>
  